import img1 from "../assets/gallery/Peru/peru1.jpg";
import img2 from "../assets/gallery/Peru/peru2.jpg";
import img3 from "../assets/gallery/Peru/peru3.jpg";
import img4 from "../assets/gallery/Peru/peru4.jpg";
import img5 from "../assets/gallery/Peru/peru5.jpg";
import img6 from "../assets/gallery/Peru/peru6.jpg";
import img7 from "../assets/gallery/Peru/peru7.jpg";
import img8 from "../assets/gallery/Peru/peru8.jpg";
import img9 from "../assets/gallery/Peru/peru9.jpg";
import img10 from "../assets/gallery/Peru/peru10.jpg";
import img11 from "../assets/gallery/Peru/peru11.jpg";
import img12 from "../assets/gallery/Peru/peru12.jpg";
import img13 from "../assets/gallery/Peru/peru13.jpg";
import img14 from "../assets/gallery/Peru/peru14.jpg";
import img15 from "../assets/gallery/Peru/peru15.jpg";
import img16 from "../assets/gallery/Peru/peru16.jpg";
import img17 from "../assets/gallery/Peru/peru17.jpg";
import img18 from "../assets/gallery/Peru/peru18.jpg";
import img19 from "../assets/gallery/Peru/peru19.jpg";
import img20 from "../assets/gallery/Peru/peru20.jpg";
import img21 from "../assets/gallery/Peru/peru21.jpg";
import img22 from "../assets/gallery/Peru/peru22.jpg";
import img23 from "../assets/gallery/Peru/peru23.jpg";
import img24 from "../assets/gallery/Peru/peru24.jpg";
import img25 from "../assets/gallery/Peru/peru25.jpg";
import img26 from "../assets/gallery/Peru/peru26.jpg";
import img27 from "../assets/gallery/Peru/peru27.jpg";
import img28 from "../assets/gallery/Peru/peru28.jpg";
import img29 from "../assets/gallery/Peru/peru29.jpg";
import img30 from "../assets/gallery/Peru/peru30.jpg";

const peruGallery = [
{ img: img1, rowSpan: 2 },
{ img: img2 },
{ img: img3 },

{ img: img4 },
{ img: img5 },
{ img: img6, rowSpan: 2 },

{ img: img7, colSpan: 2 },

{ img: img8 },
{ img: img9, rowSpan: 2 },
{ img: img10 },

{ img: img11 },
{ img: img12 },
{ img: img13 },

{ img: img14, colSpan: 2 },
{ img: img15 },

{ img: img16 },
{ img: img17, rowSpan: 2 },
{ img: img18 },

{ img: img19, colSpan: 2 },

{ img: img20 },
{ img: img21 },
{ img: img22 },

{ img: img23, rowSpan: 2 },
{ img: img24 },
{ img: img25 },

{ img: img26, colSpan: 2 },
{ img: img27 },

{ img: img28 },
{ img: img29 },
{ img: img30 },
];

export default peruGallery;
